import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useCurrentUser } from '@/lib/use-current-user';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const user = useCurrentUser();

  if (user === undefined) {
    return (
      <main className="min-h-screen flex items-center justify-center text-muted-foreground">
        Загрузка...
      </main>
    );
  }

  if (user === null) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
